
import React from 'react';
import { Lightbulb, Heater, Tv, Fan, Power, Monitor, Server } from 'lucide-react';

export const getLoadIcon = (type: string) => {
  switch (type) {
    case 'lighting':
      return <Lightbulb className="h-5 w-5 text-amber-500" />;
    case 'hvac':
      return <Heater className="h-5 w-5 text-rose-500" />;
    case 'entertainment':
      return <Tv className="h-5 w-5 text-blue-500" />;
    case 'cooling':
      return <Fan className="h-5 w-5 text-cyan-500" />;
    case 'computing':
      return <Monitor className="h-5 w-5 text-purple-500" />;
    case 'server':
      return <Server className="h-5 w-5 text-indigo-500" />;
    default:
      return <Power className="h-5 w-5 text-gray-500" />;
  }
};
